import FlexGrid, { FlexGridColumn } from '../../../../components/FlexGrid';
import PaddingBox from '../../../../components/PaddingBox';
import { isMobileAny } from '../../../../utils/device';
import { MovingGradient } from '../../../../components/MovingGradient';

function ManagementInformationLoadingPlaceholder() {
	return (
		<PaddingBox
			topExtraLarge={!isMobileAny}
			topSmall={isMobileAny}
			hrSmall
		>
			<FlexGrid
				gap='extraLarge'
				center
				hrCenter
				column={isMobileAny}
				style={{
					maxWidth: '890px',
					margin: '0 auto',
				}}
			>
				<FlexGridColumn>
					<FlexGrid
						gap='small'
						column
						center
					>
						<MovingGradient
							height='36px'
							width='165px'
						/>
						<MovingGradient
							height='36px'
							width='280px'
						/>
						<MovingGradient
							height='70px'
							width='100%'
						/>
						<MovingGradient
							height='24px'
							width='177px'
						/>
					</FlexGrid>
				</FlexGridColumn>
				<FlexGridColumn>
					<MovingGradient
						height={isMobileAny ? '140px' : '250px'}
						width={isMobileAny ? 'calc(100vw - 32px)' : '400px'}
					/>
				</FlexGridColumn>
			</FlexGrid>
		</PaddingBox>
	);
}

export { ManagementInformationLoadingPlaceholder };
